// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import PageSkeleton from "./PageSkeleton";

// const GlobalLoading = ({ children }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const requestCount = useRef(0);

//   useEffect(() => {
//     // 🔥 ONE COMMON FUNCTION FOR BOTH REQUEST & RESPONSE
//     const shouldDisableLoading = (config) => {
//       const tab = sessionStorage.getItem("tab");
//       const innerTab = sessionStorage.getItem("innerTab");
//       const currentPath = window.location.pathname;

//       // ⚠️ Your route spelling is "consultaion"
//       const isConsultationPage = currentPath.includes("consultaion");

//       return (
//         (isConsultationPage && tab === "ConsultationSinglePage") &&
//         (isConsultationPage && innerTab === "Vitals") ||
//         config?.skipGlobalLoading
//       );
//     };

//     // 🔹 REQUEST INTERCEPTOR
//     const requestInterceptor = axios.interceptors.request.use(
//       (config) => {
//         if (shouldDisableLoading(config)) {
//           return config;
//         }

//         requestCount.current += 1;
//         setIsLoading(true);

//         return config;
//       },
//       (error) => Promise.reject(error)
//     );

//     // 🔹 RESPONSE INTERCEPTOR
//     const responseInterceptor = axios.interceptors.response.use(
//       (response) => {
//         if (shouldDisableLoading(response.config)) {
//           return response;
//         }

//         requestCount.current -= 1;

//         if (requestCount.current <= 0) {
//           requestCount.current = 0;
//           setIsLoading(false);
//         }

//         return response;
//       },
//       (error) => {
//         if (shouldDisableLoading(error.config)) {
//           return Promise.reject(error);
//         }

//         requestCount.current -= 1;

//         if (requestCount.current <= 0) {
//           requestCount.current = 0;
//           setIsLoading(false);
//         }

//         return Promise.reject(error);
//       }
//     );

//     return () => {
//       axios.interceptors.request.eject(requestInterceptor);
//       axios.interceptors.response.eject(responseInterceptor);
//     };
//   }, []);

//   return (
//     <div className="relative">
//       {children}

//       {isLoading && (
//         <div className="absolute inset-0 bg-white-A700 z-50">
//           <PageSkeleton />
//         </div>
//       )}
//     </div>
//   );
// };

// export default GlobalLoading;

import React from "react";
import PageSkeleton from "./PageSkeleton";

// className is optional and additive (defaults to unused) -- lets a caller
// that needs this wrapper to stretch inside a flex layout (e.g. a grid area
// that should fill its remaining container height) pass e.g. "flex-1
// min-h-0 flex flex-col h-full" without affecting any existing caller that
// doesn't pass it.
const GlobalLoading = ({ isLoading, children, className = "" }) => {
  return (
    <div className={`relative ${className}`.trim()}>
      {children}

      {isLoading && (
        <div className="absolute inset-0 bg-white-A700 z-50">
          <PageSkeleton />
        </div>
      )}
    </div>
  );
};

export default GlobalLoading;

